import { App, Modal, Form, Input, notification, Button, Spin, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { _T } from '../../../../../base-react/src/Localization';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var FederationSource = models.federations.FederationSource;
var CompetitionsSource = models.competitions.CompetitionsSource;
var EventSource = models.competitions.EventSource;
const { Option } = Select;
export const EventCompetitionEdit = (props) => {
    const { event_id, item, visible, onClose, disabled } = props;
    const [federations, loadingFederations, errorFederations] = Stream(FederationSource);
    const { modal } = App.useApp();
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    useEffect(() => {
        if (form) {
            form.resetFields();
        }
    }, [item, form]);
    const onFinish = (fieldsValue) => {
        setIsLoading(true);
        form
            .validateFields()
            .then(fieldsValue => {
            var _a;
            const updateItem = {
                ...item,
                ...fieldsValue,
                competition_federation: (_a = federations === null || federations === void 0 ? void 0 : federations.find(a => a.federation_id == fieldsValue['federation_id'])) === null || _a === void 0 ? void 0 : _a.federation_tag
            };
            setIsLoading(true);
            if (item && item.competition_id) {
                Api.update(`${CompetitionsSource.url}/${item.competition_id}`, updateItem)
                    .then(() => {
                    setIsLoading(false);
                    onClose();
                })
                    .catch((err) => {
                    setIsLoading(false);
                    notification.error({
                        message: err.name
                    });
                });
            }
            else {
                Api.create(EventSource(event_id).url, updateItem)
                    .then(() => {
                    setIsLoading(false);
                    onClose();
                })
                    .catch((err) => {
                    setIsLoading(false);
                    notification.error({
                        message: err.name
                    });
                });
            }
        })
            .catch(() => {
            setIsLoading(false);
        });
    };
    const handleDelete = () => {
        if (!item) {
            return;
        }
        modal.confirm({
            title: _T('common.delete.title', { name: _T('competition.title').toLowerCase() }),
            content: _T('common.delete.content', { name: item.competition_name }),
            onOk() {
                setIsLoading(true);
                Api.destroy(`${CompetitionsSource.url}/${item.competition_id}`)
                    .then(() => {
                    setIsLoading(false);
                    onClose();
                    window.location.reload(); // TODO: Fix competition events not triggering
                })
                    .catch((err) => {
                    setIsLoading(false);
                    notification.error({
                        message: err.name
                    });
                });
            }
        });
    };
    if (!item) {
        return React.createElement(Form, { form: form });
    }
    return (React.createElement(Modal, { title: _T('competition.details.title'), open: visible, onCancel: onClose, footer: [
            item && item.competition_id &&
                React.createElement(Button, { key: "delete", type: "dashed", onClick: handleDelete, danger: true, disabled: loadingFederations || isLoading || disabled }, _T('common.delete.title')),
            React.createElement(Button, { key: "cancel", onClick: onClose, disabled: isLoading || disabled }, _T('common.cancel.title')),
            React.createElement(Button, { key: "submit", type: "primary", form: `competition_item_settings_${item === null || item === void 0 ? void 0 : item.competition_id}`, htmlType: 'submit', disabled: loadingFederations || disabled, loading: isLoading }, _T('common.save')),
        ] }, loadingFederations ? React.createElement(Spin, null) :
        React.createElement(Form, { name: `competition_item_settings_${item === null || item === void 0 ? void 0 : item.competition_id}`, form: form, onFinish: onFinish, disabled: disabled, initialValues: {
                ...item
            } },
            React.createElement(Form.Item, { name: "competition_name", rules: [{ required: true, message: _T('common.required') }] },
                React.createElement(Input, { autoFocus: true, disabled: isLoading, allowClear: true, placeholder: _T('competition.details.competition_name.placeholder') })),
            React.createElement(Form.Item, { name: "federation_id", rules: [{ required: true, message: _T('common.required') }] },
                React.createElement(Select, { placeholder: _T('competition.details.federation_id.label') }, federations && federations.map((federation, index) => (React.createElement(Option, { value: federation.federation_id, key: index }, federation.federation_name))))))));
};
